var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83515 24C1.33955 24 0.909791 23.818 0.545886 23.454C0.181962 23.0902 0 22.6605 0 22.1648V1.83515C0 1.33955 0.181962 0.909791 0.545886 0.545886C0.909791 0.181962 1.33955 0 1.83515 0H13.5453C14.0409 0 14.4707 0.181962 14.8346 0.545886C15.1985 0.909791 15.3805 1.33955 15.3805 1.83515V22.1648C15.3805 22.6605 15.1985 23.0902 14.8346 23.454C14.4707 23.818 14.0409 24 13.5453 24H1.83515ZM1.83515 19.7406V22.1648H13.5453V19.7406H1.83515ZM7.69495 21.7608C7.92525 21.7608 8.11672 21.6829 8.26936 21.5271C8.422 21.3713 8.49832 21.1783 8.49832 20.948C8.49832 20.7177 8.42043 20.5262 8.26465 20.3736C8.10885 20.221 7.91581 20.1446 7.68552 20.1446C7.45522 20.1446 7.26375 20.2225 7.11111 20.3783C6.95847 20.5341 6.88216 20.7271 6.88216 20.9574C6.88216 21.1877 6.96004 21.3792 7.11582 21.5319C7.27162 21.6845 7.46466 21.7608 7.69495 21.7608ZM1.83515 18.1244H13.5453V4.25939H1.83515V18.1244ZM1.83515 2.64323H13.5453V1.83515H1.83515V2.64323Z",
    fill: "#1B544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.927bd83d293327f8fb373c9ed7f5e81e.svg";
export { ForwardRef as ReactComponent };